// TODO aren't they the same? because it seems to work same, regardless the GET parameter
import {isConnectLogin} from "utils/toggleConnectOdp.js";

/**
 * redirect to ODP login form
 */
export function login() {
    if (isConnectLogin()) {
        window.location.href = ENVIRONMENT.APPROVAL_CONNECT_LOGIN_ROOT + "/start?rd=" + encodeURIComponent(window.location.href);
    } else {
        window.location.href = ENVIRONMENT.ODP_LOGIN_SERVER + "loginPage.xhtml?msgCode=NOTLOGGEDIN&requestedPage=" + encodeURIComponent(ENVIRONMENT.PUBLIC_URL);
    }
}

/**
 * redirect to ODP login form with cancelling of user session
 */
export function logout() {
    // eslint-disable-next-line
    if (isConnectLogin()) {
        window.location.href = ENVIRONMENT.APPROVAL_CONNECT_LOGIN_ROOT + "/sign_out?rd=" + encodeURIComponent(ENVIRONMENT.CONNECT_END_SESSION_ENDPOINT);
    } else {
        window.location.href = ENVIRONMENT.ODP_LOGIN_SERVER + "loginPage.xhtml?msgCode=LOGOUT&requestedPage=" + encodeURIComponent(ENVIRONMENT.PUBLIC_URL);
    }
}

/**
 * user box contains link to user details in ODP
 * @returns {string}
 */
export function myDetailsUrl() {
    // eslint-disable-next-line
    return ENVIRONMENT.ACCOUNT_SETTINGS_BASE_URL + "?client_id=odp";
}
